import { fetchWithTimeout } from './api.fetcher'

export const ping = async(token) => {
    const formData = new FormData()
    formData.append('origin', 'frontend')
    return fetchWithTimeout(`auth/ping`, {
        method: 'post',
        body: formData,
        headers : { Authorization : `Bearer ${token}` }
    })
}

export const login = async(email,password) => {
    const formData = new FormData()
    formData.append('orgin', 'terminal')
    formData.append('email', email)
    formData.append('password', password)
    return fetchWithTimeout(`auth/login`, {
        method: 'post',
        body: formData,
        headers : {}
    })
}

export const logout = async(token) => {
    const formData = new FormData()
    formData.append('orgin', 'frontend')
    return fetchWithTimeout(`auth/logout`, {
        method: 'post',
        body: formData,
        headers : { Authorization : `Bearer ${token}` }
    })
}

export const switchSesion = async(token, id) => {
    const formData = new FormData()
    formData.append('orgin', 'frontend')
    formData.append('id',id)
    return fetchWithTimeout(`auth/switch`, {
        method: 'post',
        body: formData,
        headers : { Authorization : `Bearer ${token}` }
    })
}

export const unSwitchSesion = async(token, hash) => {
    const formData = new FormData()
    formData.append('orgin', 'frontend')
    formData.append('switch',hash)
    return fetchWithTimeout(`auth/unswitch`, {
        method: 'post',
        body: formData,
        headers : { Authorization : `Bearer ${token}` }
    })
}

export const getUser = async(token) => {
    const formData = new FormData()
    formData.append('orgin', 'frontend')
    return fetchWithTimeout(`auth/users/get`, {
        method: 'post',
        body: formData,
        headers : { Authorization : `Bearer ${token}` }
    })
}

export const updateCodigoPassword = async(email) => {
    const formData = new FormData()
    formData.append('orgin', 'frontend')
    formData.append('email', email)
    return fetchWithTimeout(`auth/update.codigo_password`, {
        method: 'post',
        body: formData,
        headers : {}
    })
}

export const updatePasswordOlvido = async(email,codigo,password) => {
    const formData = new FormData()
    formData.append('orgin', 'frontend')
    formData.append('email', email)
    formData.append('codigo', codigo)
    formData.append('password', password)
    return fetchWithTimeout(`auth/update.password.olvido`, {
        method: 'post',
        body: formData,
        headers : { }
    })
}

export const updatePasswordSession = async(token,current,nueva) => {
    const formData = new FormData()
    formData.append('origin', 'frontend')
    formData.append('password_current', current)
    formData.append('password_new', nueva)
    return fetchWithTimeout(`auth/update.password`, {
        method: 'post',
        body: formData,
        headers : { Authorization : `Bearer ${token}` }
    })
}

export const updateUserSession = async(
    token, name, celular, fileAvatar = null, 
) => {

    const formData = new FormData()
    formData.append('origin', 'frontend')
    formData.append('name', name)
    formData.append('celular', celular)
    if(fileAvatar){
        formData.append('avatar',fileAvatar)
    }

    return fetchWithTimeout(`auth/update.user`, {
        method: 'post', body: formData,
        headers : { Authorization : `Bearer ${token}` }
    })
}
